const CheckDefault = () => {
  return (
    <svg width="31" height="20" viewBox="0 0 31 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.7703 11.0539L20.7505 10.1015L30.1667 0.952381L29.1866 0L10.5632 18.0953L1.14693 8.94607L0.166748 9.89845L9.58305 19.0477L10.5631 20L19.7703 11.0539Z"
        fill="#0B2341"
      />
    </svg>
  )
}

export default CheckDefault
